export class HotspotSettings {
  MuteVideoOnLoad = false;
  ReceiversVisibleOnLoad = true;
}
